export const overlayStyles = {
  position: 'fixed',
  inset: 0,
  zIndex: ({ zIndex }) => zIndex.modal,
  backgroundColor: 'rgba(10, 11, 13, 0.42)',
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  padding: '64px 12px 0',
};

export const paletteCardStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  backdropFilter: 'saturate(180%) blur(22px)',
  WebkitBackdropFilter: 'saturate(180%) blur(22px)',
  border: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  borderRadius: '20px',
  boxShadow: ({ palette }) => palette.shadow?.m ?? '0 24px 56px rgba(16,19,28,.16)',
  overflow: 'hidden',
  maxHeight: '70vh',
  display: 'flex',
  flexDirection: 'column',
};

export const searchRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '14px 18px',
  borderBottom: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  flexShrink: 0,
};

export const searchInputStyles = {
  flex: 1,
  border: 'none',
  background: 'transparent',
  outline: 'none',
  fontSize: '18px',
  color: ({ palette }) => palette.text.primary,
  fontFamily: 'inherit',
  '&::placeholder': {
    color: ({ palette }) => palette.text.disabled,
  },
};

export const resultsListStyles = {
  overflowY: 'auto',
  flex: 1,
};

export const sectionLabelStyles = {
  padding: '12px 18px 6px',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

export const resultItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 18px',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  width: '100%',
  textAlign: 'left',
  WebkitTapHighlightColor: 'transparent',
  '&:hover, &:focus': {
    backgroundColor: ({ palette }) => palette.primary.soft ?? palette.action.hover,
    outline: 'none',
  },
};

export const resultIconStyles = {
  width: '30px',
  height: '30px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: 'text.secondary',
};

export const resultTitleWrapperStyles = {
  flex: 1,
  minWidth: 0,
};

export const emptyStateStyles = {
  padding: '24px 18px',
  textAlign: 'center',
};

export const searchIconStyles = {
  display: 'flex',
  color: 'primary.main',
};
